import Administracion from  './Administracion';

export default Administracion;